// extracted by mini-css-extract-plugin
export default {"displayError":"DisplayError_displayError__3To9s"};